import { render, staticRenderFns } from "./DashboardCardDeposit.vue?vue&type=template&id=537dd993&scoped=true&"
import script from "./DashboardCardDeposit.vue?vue&type=script&lang=js&"
export * from "./DashboardCardDeposit.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCardDeposit.vue?vue&type=style&index=0&id=537dd993&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537dd993",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VDataTable,VDivider,VSpacer})
